import React, { useState } from "react";
import WhiteBgCard from "../../WhiteBgCard";
import AccountsDashboardCommonHeader from "../freshIntentSignals/AccountsDashboardCommonHeader";
import AccountsDashboardSeeAllModal from "../AccountsDashboardSeeAllModal";
import SimilarAccountCard from "./SimilarAccountCard";
import BorderBottomCard from "../../BorderBottomCard";

const SimilarAccounts = ({
  accounts = [],
  referenceAccounts = [],
  lastSyncedAt = null,
  isLoading = false,
}) => {
  const [seeAllOpen, setSeeAllOpen] = useState(false);

  return (
    <WhiteBgCard className="p-4">
      <div className="flex flex-col gap-2.5">
        <AccountsDashboardCommonHeader
          title="Similar Targets"
          tooltipContent="Net-new companies discovered from your strongest engaged accounts in the last 90 days. Existing accounts are excluded."
          seeAllButtonText="See All"
          onSeeAll={
            accounts.length > 0 || referenceAccounts.length > 0
              ? () => setSeeAllOpen(true)
              : undefined
          }
        />
        {referenceAccounts.length > 0 ? (
          <p className="text-[0.65rem] text-gray-400 dark:text-gray-500">
            Based on {referenceAccounts.length} engaged account{referenceAccounts.length === 1 ? "" : "s"}
          </p>
        ) : null}
        <div className="max-h-[310px] overflow-y-auto">
          {isLoading ? (
            <div className="flex flex-col w-full">
              {[1, 2, 3, 4, 5].map((i) => (
                <BorderBottomCard
                  key={i}
                  className="animate-pulse flex items-center justify-between gap-2"
                >
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <div className="w-8 h-8 rounded-full bg-gray-200 shrink-0" />
                    <div className="flex flex-col gap-1.5 flex-1 min-w-0">
                      <div className="h-3 w-28 rounded bg-gray-200" />
                      <div className="h-2.5 w-36 rounded bg-gray-200" />
                    </div>
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    <div className="w-7 h-7 rounded-full bg-gray-200 shrink-0" />
                    <div className="w-4 h-4 rounded bg-gray-200 shrink-0" />
                  </div>
                </BorderBottomCard>
              ))}
            </div>
          ) : accounts.length === 0 ? (
            <p className="text-[0.8rem] text-gray-500 py-8 text-center min-h-[270px] w-full flex items-center justify-center">
              No new similar targets found yet.
            </p>
          ) : (
            accounts.slice(0, 5).map((account, index) => (
              <SimilarAccountCard
                key={account?.company_domain || `similar-${index}`}
                account={account}
              />
            ))
          )}
        </div>
      </div>
      <AccountsDashboardSeeAllModal
        isOpen={seeAllOpen}
        onClose={() => setSeeAllOpen(false)}
        variant="similar"
        title="Similar accounts to target"
        description="Net-new web-researched companies. Existing accounts are excluded."
        items={accounts}
        referenceAccounts={referenceAccounts}
        lastSyncedAt={lastSyncedAt}
      />
    </WhiteBgCard>
  );
};

export default SimilarAccounts;
